import { RootState } from "application/store/reducers/rootReducer";

export const buildPersonalDataDto = (data: RootState) => {
  const {
    TercerPasoState: personalDataState,
    CuartoPasoState: mainDataState,
    SucursalProductoReducer: { codigo },
    SeleccionarProductoState: { isCredito, isPymes },
    PackOfferState: { subsidiaryOrigin },
    ActivityReducer: activityReducer,
    ContrataSeguroState: { requestInsurance },
    enrollmentUserReducer: { enrollmentId, updatedAt },
    applyBiometricReducer: { applyBiometric },
  } = data;

  let fullFirstName = personalDataState.name;
  if (personalDataState.secondName) {
    fullFirstName += ` ${personalDataState.secondName}`;
  }

  const birthdate = `${personalDataState.birthdayDay}/${personalDataState.birthdayMonth}/${personalDataState.birthdayYear}`;
  const personalData = {
    prospectName: {
      givenName: fullFirstName,
      lastName: personalDataState.lastName,
      secondLastName: personalDataState.secondLastName,
      secondName: personalDataState.secondName,
    },
    genderCode: personalDataState.sex,
    birthdate,
    countryOfBirth: personalDataState.birthdayCountryCode,
    countryOfResidence: personalDataState.residencyCountryCode,
    emailAddress: personalDataState.email,
    mobileNumber: personalDataState.phone.replace(/\D/g, ""),
    subsidiaryOrigin: isCredito ? String(subsidiaryOrigin) : codigo,
    requestInsurance: requestInsurance,
    biometricEnrollmentId: applyBiometric ? enrollmentId : null,
    biometricDateTime: applyBiometric ? (updatedAt ? updatedAt : null) : null,
    civilStatus: isPymes
      ? activityReducer.civilState
      : mainDataState.civilState,
    ...buildPersonalAddressDto(data),
  };

  return personalData;
};

export const buildPersonalAddressDto = (data: RootState) => {
  const { SeptimoPasoState: addressState } = data;
  const { QuintoPasoState: deliveryState } = data;
  const { SeleccionarProductoState: { isPymes } } = data;
  const { ActivityReducer: activityReducer } = data;

  let addressObject = addressState;
  let storedAddress = false;

  if (
    !addressState.ciudad &&
    deliveryState.ciudad &&
    deliveryState.guardarDomicilio
  ) {
    addressObject = deliveryState;
    storedAddress = true;
  }

  if (
    isPymes &&
    activityReducer &&
    activityReducer.isMainDomicile &&
    activityReducer.establishmentAddress
  ) {
    const est = activityReducer.establishmentAddress;
    addressObject = {
      ciudad: est.city || "",
      departamento: est.department || "",
      calle: est.street || "",
      numero: est.number || "",
      datosComplementarios: est.additionalInfo || "",
      numeroDeApartamento: est.apartmentNumber || "",
    };
    storedAddress = true;
  }

  return {
    livesAtCertificateAddress: storedAddress || addressState.vivoEnDomicilio,
    personalAddress: {
      city: (addressObject.ciudad || "").toUpperCase(),
      department: (addressObject.departamento || "").toUpperCase(),
      streetName: addressObject.calle,
      streetBuildingIdentification: addressObject.numero,
      complementaryData: addressObject.datosComplementarios,
      apartmentNumber: addressObject.numeroDeApartamento,
    },
  };
};
